import { MembershipsSpotifyIntegrationsApiClient } from '@fourthwall/services/dist/MembershipsSpotifyIntegrationsApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useCreatePodcastMutation = createMutationHook(
  MembershipsSpotifyIntegrationsApiClient.createPodcast,
  {
    mutationKey: ['createPodcast'],
  },
)
